import { type Timeframe } from './useStudentGenerateMessageMutation';

export type RangeOption = '7d' | '14d' | '30d' | '90d';

export type ApiDateParams =
  | { range: RangeOption; start?: never; end?: never }
  | { start: string; end: string; range?: never };

export function timeframeToApiParams(timeframe: Timeframe, periodCreatedAt: string): ApiDateParams {
  const today = new Date().toISOString().slice(0, 10);
  switch (timeframe) {
    case '24h':
      return { start: today, end: today };
    case '7d':
      return { range: '7d' };
    case '14d':
      return { range: '14d' };
    case '30d':
      return { range: '30d' };
    case '90d':
      return { range: '90d' };
    case 'all':
      return { start: periodCreatedAt.slice(0, 10), end: today };
  }
}
